import fileExtensionToOfficeFileType from 'owa-file/lib/utils/fileExtensionToOfficeFileType';
import { FileSuggestion } from 'owa-search-service/lib/data/schema/SuggestionSet';

export default function getIsFileImmersiveViewSupported(suggestion: FileSuggestion): boolean {
    const officeFileType = fileExtensionToOfficeFileType(suggestion.FileExtension);
    const isOfficeFile = officeFileType !== '' && officeFileType !== 'Visio';
    const isPdf = suggestion.FileExtension.toLowerCase() === 'pdf';
    return isOfficeFile || (isPdf && suggestion.FileType !== 'Link');
}
